export function trackPageChange() {
  if (!window.$TB || !window.$TB.hooks) return;

  // eslint-disable-next-line
  $TB.hooks.fireEvent("pageChange", null, {"sendBeacon": true});
}